import { useState, useEffect } from 'react';
import {
  collection, onSnapshot, addDoc, updateDoc, deleteDoc,
  doc, serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';

export function usePassengers(clientId) {
  const [passengers, setPassengers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientId) { setLoading(false); return; }
    const unsub = onSnapshot(collection(db, 'clients', clientId, 'passengers'), snap => {
      const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      // Sorted here rather than with a Firestore orderBy: orderBy is byte-ordered, so "alice"
      // would land after "Zoe", and it silently drops any document missing the field — a
      // passenger with no first name would vanish from the list entirely. localeCompare is
      // case-insensitive and keeps everyone. Lists are per-client and small.
      rows.sort((a, b) =>
        (a.firstName || '').localeCompare(b.firstName || '', 'en-AU', { sensitivity: 'base' }) ||
        (a.lastName  || '').localeCompare(b.lastName  || '', 'en-AU', { sensitivity: 'base' })
      );
      setPassengers(rows);
      setLoading(false);
    });
    return unsub;
  }, [clientId]);

  const addPassenger = (data) =>
    addDoc(collection(db, 'clients', clientId, 'passengers'), {
      ...data,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });

  const updatePassenger = (id, data) =>
    updateDoc(doc(db, 'clients', clientId, 'passengers', id), {
      ...data,
      updatedAt: serverTimestamp(),
    });

  const deletePassenger = (id) =>
    deleteDoc(doc(db, 'clients', clientId, 'passengers', id));

  return { passengers, loading, addPassenger, updatePassenger, deletePassenger };
}
